<h1>{{ 'turbo.core.SmsDialog.txtHeadline' | translate : 'Send sms to' }}<span *ngIf="receiver"> {{ receiver }}</span></h1>
<div>
    <div>
        <mat-form-field style="width: 100%; min-width: 300px;">
            <textarea matInput placeholder="{{'turbo.core.SmsDialog.txtMessage' | translate : 'Type your message here...'}}" required [(ngModel)]="message" matTextareaAutosize matAutosizeMinRows="9" matAutosizeMaxRows="9" [required] [disabled]="sending"></textarea>
        </mat-form-field>
    </div>
    <div style="text-align: center;">
        <button mat-button style="margin: 2px;" color="primary" (click)="send()" [disabled]="!message || sending">{{ 'turbo.core.SmsDialog.cmdSend' | translate : 'Send' }}</button>
        <button mat-button style="margin: 2px;" [mat-dialog-close]="'Cancel'">{{ 'turbo.core.messagebox.cmdCancel' | translate : 'Cancel' }}</button>
    </div>
</div>
<mat-progress-bar mode="indeterminate" style="margin-left: -24px; margin-bottom: -24px; width: calc(100% + 48px); margin-top: 24px;" *ngIf="sending"></mat-progress-bar>
